import {
	ONBOARD_USER_REGISTRATION,
	SHOW_ALERT,
	SEND_OTP,
	VERIFY_OTP,
	RESET_SIGNUP_MODULE,
	GET_RETAILER_BY_PHONE
} from "../action-types";

import {
	sendOTPSuccess,
	verifyOTPSuccess,
	resetSignUpModule,
	setDefaultUploadedDocuments
} from "../mutation-types";

import { DEFAULT_ERROR_MESSAGE } from "@/store/config";
import { BASE_URL, JEET11_API_GATEWAY_BASE_URL } from "../../../config";
import ApiService from "@/store/api-service";

const state = {
	authenticationId: null,
	onBoardUser: null
};

const initialState = Object.assign({}, state);

const actions = {
	[ONBOARD_USER_REGISTRATION.action]: ({ dispatch }, payload) => {
		let endpoint = BASE_URL + "/retailer/v1.0.0/registration";
		let requestPayload = {
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "string"
				) {
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},

	[SEND_OTP.action]: ({ commit, dispatch }, payload) => {
		const endpoint = BASE_URL + "/retailer/v1.0.0/sendOtp";
		const requestPayload = {
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object" &&
					data.response.id
				) {
					commit(sendOTPSuccess, data.response.id);
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "OTP sent successfully!" },
						{ root: true }
					);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},

	[VERIFY_OTP.action]: (
		{ commit, dispatch },
		{ phone, isDistributor, ...payload }
	) => {
		const endpoint = BASE_URL + "/retailer/v1.0.0/verifyOtp";
		const requestPayload = {
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				// console.log(data);
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					data.response = {
						...data.response,
						phone,
						isDistributor
					};
					commit("verifyOTPSuccess", data.response);
					const { userDetails } = data.response;
					if (userDetails) {
						const {
							GSTCertificate,
							IDProof,
							agreement,
							COI
						} = userDetails;
						commit(
							`uploadMedia/${setDefaultUploadedDocuments}`,
							{
								GSTCertificate,
								IDProof,
								agreement,
								COI
							},
							{ root: true }
						);
					}
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},
	[RESET_SIGNUP_MODULE.action]: ({ commit }) => {
		commit(resetSignUpModule);
	},
	[GET_RETAILER_BY_PHONE.action]: ({ dispatch }, payload) => {
		const endpoint =
			JEET11_API_GATEWAY_BASE_URL +
			"user-service/external/v1.0.0/retailer-data-by-phone";
		const requestPayload = {
			...payload
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.status === "success") {
					return data;
				} else if (data.message) {
					errMsg = data.message;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	}
};

const mutations = {
	[sendOTPSuccess](state, payload) {
		state.authenticationId = payload;
	},
	[verifyOTPSuccess](state, payload) {
		let username = `r${payload.phone}`;
		if (payload.isDistributor) {
			username = `d${payload.phone}`;
		}
		state.onBoardUser = {
			...payload,
			username: username
		};
	},
	[resetSignUpModule](state) {
		Object.keys(initialState).map(key => {
			state[key] = initialState[key];
		});
	}
};

export default {
	namespaced: true,
	state,
	actions,
	mutations
};
